import './Toast.css';

import React, { useEffect, useState } from 'react';
import classname from '@search/classname/src';

import { Button, Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

const cn = classname.bind(null, 'Toast');

interface ToastProps {
    text: string;
    onClose?: () => void;
    buttonText?: string;
    buttonClick?: () => void;
    isMobile?: boolean;
    isVisible?: boolean;
    isHeader?: boolean;
    isLong?: boolean;
}

export const Toast = ({
    text,
    buttonText,
    onClose,
    buttonClick,
    isVisible = false,
    isMobile,
    isHeader = false,
    isLong = false
}: ToastProps) => {
    const [ isSticky, setIsSticky ] = useState(false);
    const [ isTransition, setTransition ] = useState(true);

    const handleScroll = () => {
        const scrollHeight = isMobile ? 124 : 70;

        if (window.scrollY > scrollHeight) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }

        if (window?.scrollY < 200) {
            setTransition(true);
        } else {
            setTransition(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            className={
                cn(
                    null,
                    {
                        sticky: isSticky,
                        mobile: isMobile,
                        visible: isVisible,
                        header: isHeader,
                        transition: isTransition,
                        long: isLong
                    }
                )}
        >
            <div className={cn('title')}>
                <Typography
                    variant={isMobile ? 'secondary-alone' : 'primary-alone'}
                    color='primary-alt-bg'
                >
                    {text}
                </Typography>
            </div>
            <div className={cn('buttonSection')}>
                {
                    ! isLong &&
                    <Button
                        onClick={buttonClick}
                        variant='secondary-alt-bg'
                        size='xs'
                    >
                        <Typography variant='secondary-alone'>{buttonText}</Typography>
                    </Button>
                }
                <Button
                    size='xs'
                    variant='transparent-alt-bg'
                    onClick={onClose}
                    overflow={false}
                >
                    <Icon name='times' size='s' color='rgba(255, 255, 255, 0.32)' />
                </Button>
            </div>
            {
                isLong &&
                <div className={cn('mobileButton')}>
                    <Button
                        onClick={buttonClick}
                        variant='secondary-alt-bg'
                        size='xs'
                        block
                    >
                        <Typography variant='secondary-alone'>{buttonText}</Typography>
                    </Button>
                </div>
            }
        </div>
    );
};
